.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  margin: 0 var(--space-16) var(--space-16);
  padding: var(--space-16);
  border: 1px solid var(--w-border);
  border-radius: 18px;
  background: var(--w-subtle);
  animation: rise 260ms var(--ease-out) both;
}

.question {
  margin: 0;
  font-weight: 600;
  text-wrap: balance;
}

.done {
  display: flex;
  gap: var(--space-8);
  align-items: flex-start;
  margin: 0;
  font-weight: 550;
}

.done :global(.icon) {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  color: var(--w-success);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  font-size: 13px;
  font-weight: 550;
  color: var(--w-muted);
}

.field input,
.field textarea {
  width: 100%;
  min-height: 44px;
  padding: var(--space-8) var(--space-12);
  border: 1px solid var(--w-border-strong);
  border-radius: 12px;
  background: var(--w-bg);
  color: var(--w-text);
  font-weight: 400;
  resize: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.field input:focus-visible,
.field textarea:focus-visible {
  border-color: var(--w-accent-text);
  outline: none;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--w-accent-text) 22%, transparent);
}

.field input[aria-invalid="true"] {
  border-color: var(--w-danger);
}

.error {
  margin: 0;
  color: var(--w-danger);
  font-size: 13px;
  font-weight: 500;
}

.privacy {
  margin: 0;
  color: var(--w-faint);
  font-size: 12px;
  line-height: 1.45;
}

.row {
  display: flex;
  gap: var(--space-8);
}

.primary,
.ghost {
  min-height: 44px;
  padding: 0 var(--space-16);
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 120ms var(--ease-out), background-color 120ms ease;
}

.primary {
  flex: 1;
  border: 0;
  background: var(--w-accent);
  color: var(--w-on-accent);
}

.primary:disabled {
  opacity: 0.6;
  cursor: default;
}

.ghost {
  border: 1px solid var(--w-border-strong);
  background: transparent;
}

.primary:active:not(:disabled),
.ghost:active {
  transform: scale(0.97);
}

@media (hover: hover) and (pointer: fine) {
  .primary:hover:not(:disabled) {
    background: var(--w-accent-strong);
  }

  .ghost:hover {
    background: var(--w-hover);
  }

  .whatsapp:hover {
    text-decoration: underline;
  }
}

/* A quieter second way to reach the office, under the form's buttons. */
.whatsapp {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: var(--space-6);
  min-height: 40px;
  margin: calc(-1 * var(--space-4)) 0 calc(-1 * var(--space-8));
  color: var(--w-text);
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  text-underline-offset: 2px;
  touch-action: manipulation;
  transition: transform 120ms var(--ease-out);
}

.whatsapp :global(.icon) {
  width: 20px;
  height: 20px;
  /* WhatsApp's own green, dark enough to read as a symbol on white and on dark. */
  color: #128c7e;
}

.whatsapp:active {
  transform: scale(0.97);
}

.whatsapp:focus-visible {
  border-radius: 6px;
  outline: 2px solid var(--w-accent-text);
  outline-offset: 2px;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    animation: none;
  }
}
